import React, { Component } from 'react';
import { Row } from 'reactstrap';
import Header2 from '../../general/Header2';
import Wrap from '../../general/Wrap';
import DreamsItem from './DreamsItem';
import styles from './Dreams.module.css';
import { observer, inject } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

@inject('DreamsStore')
@observer
class Dreams extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Wrap>
                <Row>
                    <Header2>Splněné sny</Header2>
                </Row>
                <Row>
                    <div className={styles.swiperWrapper}>
                        <button className={styles.prev}>‹</button>
                        <Swiper
                            modules={[Pagination, Navigation]}
                            spaceBetween={5}
                            pagination={{
                                clickable: true,
                                dynamicBullets: true,
                                dynamicMainBullets: 3,
                            }}
                            navigation={{
                                prevEl: `.${styles.prev}`,
                                nextEl: `.${styles.next}`,
                            }}
                            autoHeight
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                640: {
                                    slidesPerView: 2,
                                },
                                1024: {
                                    slidesPerView: 3,
                                }
                            }}
                        >
                            {this.props.DreamsStore.items.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <DreamsItem item={item} key={item.id} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <button className={styles.next}>›</button>
                    </div>
                </Row>
            </Wrap>
        );
    }
}

export default Dreams